module.exports = __webpack_public_path__ + "img/Clara.bc6e9b90.png";